import type { ChargeStatusEnum } from '@bambi/api-client/schemas';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { NumberRangeValue } from 'src/common/primitives/NumberRangeFilterPopover/NumberRangeFilterPopover';
import { hasRangeFilter } from 'src/common/primitives/NumberRangeFilterPopover/NumberRangeFilterPopover';

interface PaymentsState {
  // Filters
  filterSearch?: string;
  filterChargeStatus?: ChargeStatusEnum[];
  filterIsManual?: boolean;
  filterCreatedAtAfter?: string;
  filterCreatedAtBefore?: string;
  filterHasRefunds?: boolean;
  filterAmountTotal?: NumberRangeValue;
}

export const initialState: PaymentsState = {};

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setFilterSearch(state, action: PayloadAction<string>) {
      state.filterSearch = action.payload;
    },
    setFilterChargeStatus(state, action: PayloadAction<ChargeStatusEnum[]>) {
      state.filterChargeStatus = action.payload;
    },
    setFilterIsManual(state, action: PayloadAction<boolean | undefined>) {
      state.filterIsManual = action.payload;
    },
    setFilterCreatedAtRange(
      state,
      action: PayloadAction<{ rangeStart?: string; rangeEnd?: string }>
    ) {
      state.filterCreatedAtAfter = action.payload.rangeStart;
      state.filterCreatedAtBefore = action.payload.rangeEnd;
    },
    setFilterHasRefunds(state, action: PayloadAction<boolean | undefined>) {
      state.filterHasRefunds = action.payload;
    },
    setFilterAmountTotal(state, action: PayloadAction<NumberRangeValue>) {
      state.filterAmountTotal = action.payload;
    },
    clearFilters(state) {
      state.filterSearch = undefined;
      state.filterChargeStatus = undefined;
      state.filterIsManual = undefined;
      state.filterCreatedAtAfter = undefined;
      state.filterCreatedAtBefore = undefined;
      state.filterHasRefunds = undefined;
      state.filterAmountTotal = undefined;
    },
  },
  selectors: {
    hasFilters(state) {
      return (
        !!state.filterSearch ||
        !!state.filterChargeStatus?.length ||
        state.filterIsManual !== undefined ||
        !!state.filterCreatedAtAfter ||
        !!state.filterCreatedAtBefore ||
        state.filterHasRefunds !== undefined ||
        hasRangeFilter(state.filterAmountTotal)
      );
    },
  },
});

export const {
  setFilterSearch,
  setFilterChargeStatus,
  setFilterIsManual,
  setFilterCreatedAtRange,
  setFilterHasRefunds,
  setFilterAmountTotal,
  clearFilters,
} = paymentsSlice.actions;

export const { hasFilters } = paymentsSlice.selectors;
